if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        
        // Nuevo: Estado para la modalidad seleccionada
        this.selectedKCGroup = null;
        
        // Nuevo: Escuchar evento de selección de modalidad
        document.addEventListener('modalidadSelected', (e) => {
          this.selectedKCGroup = e.detail.kcGroup;
        });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        this.selectedKCGroup = null;
        document.dispatchEvent(new Event('product:reset'));
      
        // Nuevo: Verificar si hay modalidad seleccionada
        if (!this.selectedKCGroup) {
          // Mostrar modal y esperar selección
          const product_id = this.form.querySelector('[name="sku"]')?.value;
          if (!product_id) {
            console.error("No se encontró el SKU en el formulario");
            return;
          }
          
          // Mostrar modal (función definida en modal-modalidad.js)
          await window.showModalidadModal(product_id);
          
          // Esperar a que el usuario seleccione y haga clic en Continuar
          return new Promise((resolve) => {
            const continueBtn = document.querySelector(".continue-btn");
            continueBtn.addEventListener('click', () => {
              if (this.selectedKCGroup) {
                this.processCartAddition(evt);
                this.selectedKCGroup = null;
                document.dispatchEvent(new Event('product:reset'));
              }
              resolve();
            }, { once: true });
          });
        } else {
          // Si ya hay modalidad seleccionada, proceder directamente
          this.processCartAddition(evt);
        }
      }

      // Nuevo: Método para procesar la adición al carrito
      processCartAddition(evt) {
        const product_id = this.form.querySelector('[name="id"]')?.value;
        if (!product_id) {
          console.error("No se encontró el SKU en el formulario");
          return;
        }

        const key = 'course_modality';
        let arr = [];
        try {
          arr = JSON.parse(localStorage.getItem(key)) || [];
        } catch (e) {
          arr = [];
        }

        const exists = arr.some(item => item.product_id === product_id);
        if (exists) {
          alert("ℹ️ Este curso ya está en tu selección.");
        } else {
          arr.push({ kc_group: this.selectedKCGroup, product_id: product_id });
          localStorage.setItem(key, JSON.stringify(arr));
          console.log("LocalStorage actualizado:", arr);
        }
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


  

